export default "__VITE_ASSET__CwMYLO$U__"